import { render, staticRenderFns } from "./VideoSlide.vue?vue&type=template&id=6e75ea9f&scoped=true"
import script from "./VideoSlide.vue?vue&type=script&lang=js"
export * from "./VideoSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e75ea9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e75ea9f')) {
      api.createRecord('6e75ea9f', component.options)
    } else {
      api.reload('6e75ea9f', component.options)
    }
    module.hot.accept("./VideoSlide.vue?vue&type=template&id=6e75ea9f&scoped=true", function () {
      api.rerender('6e75ea9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/VideoSlide.vue"
export default component.exports